'use strict';
const _ = require('underscore');
const Ajax = require('common/infra/ajax');

class API {
    /**
     * Comment 一覧を取得する
     *
     * @param projectID
     * @param diagramID
     * @returns {*}
     */
    // TODO: getNextByRelatedKey に統合予定
    getComments(projectID, diagramID) {
        return Ajax.GET(`/api/projects/${projectID}/diagrams/${diagramID}/comments`);
    }

    /**
     * RelatedKey を持つ Comment 一覧を取得する
     *
     * @param projectID
     * @param relatedKey
     * @param limit {number}
     * @param cursor {string}
     * @param options
     * @returns {*}
     */
    getNextByRelatedKey(projectID, relatedKey, limit, cursor, options) {
        // 本来であれば path にクエリパラメータも含んだ状態で readmore を管理すべきだが、
        // (クエリパラメータが違えばリストに含まれるものが異なるので)
        // 実装速度を優先するため単純にクエリパラメータ（pathOptions）を含めない path での管理にする
        const urlsafeKey = relatedKey.toUrlsafeString();
        const path = `/api/projects/${projectID}/comments?key=${urlsafeKey}`;
        let params = new URLSearchParams();

        if (limit) {
            params.append('limit', `${limit}`);
        }

        if (options && options.direction) {
            params.append('direction', options.direction);
        }

        if (options && options.flat) {
            params.append('withChildren', 'false');
        } else {
            params.append('filter', 'parentOnly');
            params.append('withChildren', 'true');
        }

        if (options && options.commentID) {
            params.append('commentID', options.commentID);
        }

        if (cursor) {
            params.append('nextCursor', cursor);
        }

        return Ajax.GET(`${path}&${params.toString()}`);
    }

    create(projectKey, json) {
        return Ajax.POST(`/api/projects/${projectKey.id}/comments`, json);
    }

    /**
     * キーワードに合致する Comment 一覧を取得する
     *
     * @param projectID
     * @param relatedKey
     * @param limit
     * @param keyword
     * @param options
     * @returns {*}
     */
    searchNextByRelatedKey(projectID, relatedKey, limit, keyword, options) {
        const urlsafeKey = relatedKey.toUrlsafeString();
        let path = `/api/projects/${projectID}/comments/search?key=${urlsafeKey}&keyword=${keyword}&limit=${limit}`;
        if(options && options.flat) {
            path += `&withChildren=false`;
        } else {
            path += `&filter=parentOnly&withChildren=true`;
        }

        // TODO: ページング処理を後で考える
        let page = 1;
        path += `&page=${page}`;

        return Ajax.GET(path)
            .then(value => {
                // TODO: ページング状態の持たせ方は、 datastore (cursor) と合わせて要検討
                // value = { total: 11, more: false, comments: [ ... ] }

                return value['comments'];
            });

    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./communication/infra/api/comment.js